import { createFileRoute } from "@tanstack/react-router";

import { VenueDialog } from "../features/venues/components/VenueDialog";
import { venueQueries } from "../features/venues/api/queries";
import { areaQueries } from "../features/weather/api/queries";
import { AppHeader } from "../shared/ui/AppHeader";

export const Route = createFileRoute("/_authenticated/venues/new")({
  loader: ({ context: { queryClient } }) =>
    // The list, because the dialog reads the row from it; the areas, because the
    // form's picker needs them before first paint.
    Promise.all([
      queryClient.ensureQueryData(venueQueries.list()),
      queryClient.ensureQueryData(areaQueries.list()),
    ]),
  component: NewVenuePage,
});

/** Chrome behind the modal; the dialog owns the form. */
function NewVenuePage() {
  return (
    <>
      <AppHeader />
      <VenueDialog venueId={null} />
    </>
  );
}
